import type { TranslationDictionary } from "./types";

export const RU_DICTIONARY: TranslationDictionary = {
    "app.newTask": "Новый",
    "app.newTaskAria": "Новый чат",
    "sidebar.searchPlaceholder": "Поисковые запросы или задача ID",
    "sidebar.filters": "Фильтры задач",
    "sidebar.allRatios": "Все соотношения",
    "sidebar.allOrientations": "Все ориентации",
    "sidebar.allModes": "Все режимы",
    "sidebar.allResolutions": "Все разрешения",
    "sidebar.activeTasks": "Активные задачи",
    "sidebar.topAnchors": "Навигация по верхнему времени",
    "sidebar.bottomAnchors": "Нижняя навигация по времени",
    "sidebar.resize": "Изменение размера боковой панели",
    "batch.selected": "0 выбрано",
    "batch.selectedCount": "{count} выбрано",
    "batch.archivedCount": "Архивированные чаты {count}",
    "batch.archiveFailed": "Пакетный архив не выполнен",
    "batch.runningCannotDeleteSelected": "Выбранные чаты активны и не могут быть удалены.",
    "batch.deleteTitle": "Удалить чаты {count}?",
    "batch.deleteMessage": "Это также приведет к удалению локальных файлов image.",
    "batch.deleteSkippedDetail": "{count} запущенные задачи будут сохранены",
    "batch.deleteSkippedSuffix": ", {count} запущенные задачи не удалены",
    "batch.deletedCount": "Удалены {count} чаты{skipped}",
    "batch.deleteFailed": "Пакетное удаление не удалось",
    "action.archive": "Архив",
    "action.delete": "Удалить",
    "action.cancel": "Отмена",
    "action.edit": "Редактировать",
    "action.clear": "Очистить",
    "action.paste": "Вставить",
    "action.find": "Найти",
    "action.replace": "Заменить",
    "action.close": "Закрыть",
    "action.confirm": "Подтвердить",
    "action.confirmQuestion": "Подтвердить действие?",
    "action.refresh": "Обновить",
    "action.save": "Сохранить",
    "action.add": "Добавить",
    "action.new": "Новый",
    "action.import": "Импорт",
    "action.export": "Экспорт",
    "queue.empty": "Нет очереди",
    "queue.emptyAria": "Статус очереди: нет задач в очереди.",
    "queue.jumpTitle": "Перейти к активным задачам",
    "queue.emptyTitle": "Нет задач в очереди",
    "queue.channel": "Каналы {count}",
    "queue.availableChannels": "Доступные каналы {usable}/{total}",
    "queue.dispatching": "Планирование · ожидание {waiting}",
    "queue.runningWaiting": "Запуск {running} · ожидание {waiting}",
    "queue.statusLabel": "Статус очереди: {text} · {channelText}. Нажмите, чтобы перейти к активным задачам",
    "queue.runningActions": "Запуск действий очереди задач",
    "queue.waitingActions": "Действия очереди задач ожидания",
    "queue.cancelRunning": "Отмена",
    "queue.cancelRunningTitle": "Отменить выполнение задачи",
    "queue.dragWaiting": "Перетащите, чтобы изменить порядок ожидающих задач",
    "queue.dragSort": "Перетащите для сортировки",
    "queue.moveUp": "Вверх",
    "queue.moveUpTitle": "Переместить ожидающую задачу вверх",
    "queue.moveDown": "Вниз",
    "queue.moveDownTitle": "Переместить ожидающую задачу вниз",
    "queue.promote": "Топ",
    "queue.promoteTitle": "Переместить ожидающую задачу наверх",
    "queue.promoteFailed": "Не удалось перейти наверх",
    "queue.deleteWaitingShort": "Дель",
    "queue.deleteWaitingTitle": "Удалить ожидающую задачу",
    "queue.deleteWaitingTitleConfirm": "Удалить ожидающую задачу?",
    "queue.deleteWaitingMessage": "Это удалит его из очереди и списка истории.",
    "queue.deleteQueuedFailed": "Не удалось удалить задачу в очереди.",
    "queue.queuedDeleted": "Задача в очереди удалена",
    "queue.cancelRunningConfirm": "Отменить задачу",
    "queue.cancelRunningTitleConfirm": "Отменить выполнение задачи?",
    "queue.cancelRunningMessage": "Текущая задача будет остановлена. История будет сохранена.",
    "queue.cancelRunningFailed": "Не удалось отменить задачу.",
    "queue.runningCancelled": "Задача отменена",
    "queue.reorderFailed": "Не удалось изменить порядок очереди.",
    "queue.realtimeUpdateFailed": "Не удалось обновить текущий статус.",
    "queue.realtimeDisconnected": "Соединение со статусом Live было потеряно. Обновите страницу для восстановления.",
    "queue.readFailed": "Не удалось загрузить очередь",
    "status.waiting": "Ожидание",
    "status.shownActiveTasks": "Показ активных задач",
    "status.jsonCopied": "JSON скопировано",
    "taskStatus.submitting": "Отправка",
    "taskStatus.running": "Создание",
    "taskStatus.runningWithElapsed": "Генерация · {elapsed}",
    "taskStatus.completed": "Завершено",
    "taskStatus.partialFailed": "Частично не удалось",
    "taskStatus.failed": "Не удалось",
    "taskStatus.queued": "В очереди",
    "taskStatus.unknown": "Неизвестный статус",
    "taskStatus.task": "Задача",
    "taskStatus.connectionInterrupted": "Соединение прервано",
    "taskStatus.lastFailed": "Последняя неудача",
    "taskStatus.waitingRetry": "{reason} ожидает повторной попытки (попытка {attempt}/{max})",
    "taskStatus.retrying": "{reason}, повторная попытка (попытка {attempt}/{max})",
    "taskStatus.nonRetryableAttempt": "Попытка {attempt}/{max}, повторная попытка невозможна.",
    "taskStatus.manualRetryAvailable": "Остановился; неудачный images можно повторить вручную",
    "taskStatus.waitingRetryShort": "Ждет повтора",
    "taskStatus.retryingShort": "Повтор",
    "taskStatus.nonRetryableShort": "Без повтора",
    "taskStatus.manualRetryShort": "Ручной повтор",
    "taskStatus.stoppedShort": "Остановлено",
    "taskStatus.runtime": "Продолжительность {duration}",
    "taskStatus.runtimeCompleted": "Продолжительность {duration} · завершено {time}",
    "taskStatus.completedAt": "Завершено {time}",
    "taskCard.count": "{count} images",
    "taskCard.successCount": "удалось {count}",
    "taskCard.failedCount": "не удалось {count}",
    "taskCard.runningCount": "создание {count}",
    "taskCard.waitingCount": "жду {count}",
    "taskCard.textToImageThumb": "Миниатюра задачи преобразования текста в image",
    "taskCard.imageToImageThumb": "Миниатюра задачи от Image до image",
    "taskCard.failedThumb": "Задача не выполнена",
    "taskCard.textBadge": "Т",
    "taskMode.edit": "Редактировать",
    "taskMode.generate": "Генерировать",
    "document.generatingQueue": "Создание · очереди {total}",
    "document.queuedWaiting": "В очереди · ожидание {count}",
    "runFeedback.editing": "Редактирование",
    "runFeedback.generating": "Создание",
    "runFeedback.status": "{action}, прошло {elapsed}",
    "footer.archive": "Архив",
    "footer.archiveCount": "Архив {count}",
    "footer.historyLibrary": "История",
    "historyLibrary.openFull": "Открыть полную библиотеку истории",
    "history.documentTitle": "История - AGENTRA IMAGE",
    "history.back": "Вернуться к генератору",
    "history.title": "История",
    "history.loading": "Загрузка",
    "history.total": "{total} задач · {archived} в архиве",
    "history.search": "Поиск",
    "history.searchPlaceholder": "Поисковые запросы или задача ID",
    "history.clear": "Очистить",
    "history.month": "Месяц",
    "history.status": "Статус",
    "history.promptMode": "Режим подсказки",
    "history.size": "Размер",
    "history.quality": "Качество",
    "history.ratio": "Соотношение",
    "history.orientation": "Ориентация",
    "history.backend": "Бэкэнд",
    "history.provider": "Поставщик",
    "history.archived": "В архиве",
    "history.all": "Все",
    "history.allMonths": "Все месяцы",
    "history.allStatuses": "Все статусы",
    "history.allPromptModes": "Все режимы",
    "history.allSizes": "Все размеры",
    "history.allQualities": "Все качества",
    "history.allRatios": "Все соотношения",
    "history.ratioOther": "Другое",
    "history.allOrientations": "Все ориентации",
    "history.allBackends": "Все бэкэнды",
    "history.allProviders": "Все провайдеры",
    "history.unarchived": "Разархивировано",
    "history.archivedOnly": "В архиве",
    "history.tasksAria": "Исторические задачи",
    "history.taskListTitle": "Исторические задачи",
    "history.browseNewest": "Сначала просматривайте новейшие",
    "history.view": "Посмотреть",
    "history.grid": "Сетка",
    "history.list": "Список",
    "history.sort": "Сортировать",
    "history.newest": "Сначала самые новые",
    "history.oldest": "Сначала самый старый",
    "history.refresh": "Обновить",
    "history.selectedCount": "Выбрано {count} задач",
    "history.confirmDelete": "Подтвердить удаление",
    "history.detail": "Подробности задачи",
    "history.detailTitle": "Историческое задание",
    "history.closeDetail": "Закрыть детали задачи",
    "history.resizeFilters": "Изменение размера боковой панели фильтра",
    "history.resizeDetail": "Изменение размера панели сведений",
    "history.detailEmpty": "Выберите историческую задачу, чтобы просмотреть подробности",
    "history.loadingDetail": "Загрузка деталей...",
    "history.loadMore": "Загрузить больше",
    "history.loadingMore": "Загрузка...",
    "history.noMore": "Больше никаких задач",
    "history.loadFailed": "Загрузка не удалась. Обновите или продолжайте прокручивать, чтобы повторить попытку.",
    "history.summaryFailed": "Не удалось загрузить сводку",
    "history.tasksFailed": "Не удалось загрузить задачи.",
    "history.detailFailed": "Не удалось загрузить детали",
    "history.noMatches": "Нет подходящих задач",
    "history.loadedCount": "{count} загружен",
    "history.windowNotice": "Установленный список ограничен задачами {count}; прокрутите вверх или вниз, чтобы восстановить соседние задачи по требованию.",
    "history.selectTask": "Выберите задачу",
    "history.viewing": "Просмотр",
    "history.noPreview": "Нет предварительного просмотра images",
    "history.downloadAll": "Скачать ZIP",
    "history.downloadSelected": "Скачать выбранное",
    "history.deleteUnselected": "Удалить невыбранное",
    "history.confirmDeleteUnselected": "Подтвердить удаление невыбранного",
    "history.selected": "Выбрано",
    "history.select": "Выбрать",
    "history.downloadIndex": "Скачать {index}",
    "history.addReference": "Добавить ссылку",
    "history.outputActions": "Результат действия image",
    "history.inputReferences": "Входные ссылки",
    "history.inputReferenceIndex": "Введите ссылку {index}",
    "history.copyPrompt": "Копировать приглашение",
    "history.copyPrompts": "Копировать подсказки",
    "history.copyPromptShort": "Копировать",
    "history.copyPromptPanel": "Скопировать {title}",
    "history.copyOutputPromptPanel": "Скопируйте исправленное приглашение image {index}.",
    "history.copyTaskIds": "Копировать идентификаторы задач",
    "history.reuseTask": "Посмотреть в генераторе",
    "history.downloadTask": "Скачать",
    "history.downloadSelectedTasks": "Пакетная загрузка",
    "history.contextMenuLabel": "Контекстное меню задачи истории",
    "history.promptCopied": "Подсказка скопирована.",
    "history.promptsCopied": "Скопированы подсказки из задач {count}.",
    "history.taskIdsCopied": "Скопированы идентификаторы задач {count}.",
    "history.promptCopiedShort": "Скопировано",
    "history.promptCopyFailed": "Не удалось скопировать запрос.",
    "history.promptCopyFailedShort": "Не удалось",
    "history.noPrompt": "Для этой задачи нет запроса на копирование",
    "history.noPromptShort": "Пустой",
    "history.downloadStarted": "Загрузка началась",
    "history.batchDownloadStarted": "Начаты загрузки для задач {count}.",
    "history.noDownloadableOutputs": "Нет загружаемого файла images",
    "history.confirmDeleteSelected": "Подтвердить выбранное удаление",
    "history.openPreview": "Открыть предварительный просмотр",
    "history.closePreview": "Закрыть предварительный просмотр",
    "history.untitled": "Без названия",
    "history.promptCompare": "Быстрое сравнение",
    "history.promptOriginal": "Оригинальная подсказка",
    "history.promptSubmitted": "Оптимизированная подсказка",
    "history.promptRevised": "Пересмотренный результат",
    "history.outputRevisedPromptTitle": "Image {index} измененное приглашение",
    "history.outputRevisedPromptNotice": "Каждый image имеет собственное измененное приглашение под image.",
    "history.promptEmpty": "Нет контента",
    "history.promptMode.strict": "Строгий",
    "history.promptMode.original": "Оригинал",
    "history.promptMode.off": "Креатив",
    "history.quality.high": "Высокий",
    "history.quality.medium": "Средний",
    "history.quality.low": "Низкий",
    "history.quality.auto": "Авто",
    "footer.batch": "Пакетный",
    "footer.storage": "Хранение",
    "footer.apiStatus": "Статус API: ОК",
    "footer.version": "Версия {version}",
    "footer.versionInfo": "Информация о версии",
    "footer.versionLoading": "Версия...",
    "footer.updateBadge": "Доступна новая версия",
    "footer.updateAvailable": "Новая версия {version}",
    "version.title": "Версия и обновление",
    "version.loading": "Чтение статуса версии",
    "version.current": "Текущая версия",
    "version.latest": "Последняя версия",
    "version.source": "Время выполнения",
    "version.sourcePortable": "Портативная упаковка",
    "version.sourceSource": "Оформление исходного кода",
    "version.upToDate": "У вас уже установлена последняя версия",
    "version.updateAvailable": "Доступна версия {version}. Закройте окно сервера WebUI, затем запустите программу обновления для обновления.",
    "version.noUpdater": "Эта среда выполнения не является переносимым пакетом, поэтому программу обновления невозможно запустить автоматически.",
    "version.openUpdater": "Запустить программу обновления",
    "version.release": "Посмотреть выпуск",
    "version.updaterStarted": "Обновление запустилось. Закройте текущее окно сервера WebUI и следуйте инструкциям программы обновления.",
    "version.updaterFailed": "Не удалось запустить программу обновления. Запустите скрипт обновления из пакета вручную.",
    "notifications.title": "Уведомления",
    "notifications.unread": "Уведомления, {count} непрочитано",
    "notifications.unreadSummary": "{count} непрочитано",
    "notifications.empty": "Нет уведомлений о задачах",
    "notifications.taskFailed": "Задача не выполнена",
    "notifications.taskPartial": "Задача частично выполнена",
    "notifications.taskCompleted": "Задача выполнена",
    "notifications.generationFailed": "Генерация не удалась",
    "notifications.successCount": "{count} удалось",
    "notifications.resultAvailable": "Доступны результаты",
    "notifications.failedCount": "{count} не удалось",
    "notifications.systemUnsupported": "Этот браузер не поддерживает системные уведомления",
    "notifications.systemBlocked": "Системные уведомления блокируются браузером. Включите их в настройках браузера.",
    "notifications.systemDenied": "Системные уведомления не включены",
    "notifications.systemEnabled": "Системные уведомления включены",
    "notifications.taskMissing": "Задача не существует или была удалена",
    "theme.label": "Тема",
    "theme.system": "Авто",
    "theme.light": "Светлая",
    "theme.dark": "Тёмная",
    "language.label": "Язык интерфейса",
    "language.zh": "中",
    "language.zhCN": "简体中文",
    "language.zhTW": "正體中文",
    "language.zhHK": "繁体中文",
    "language.ja": "日本語",
    "language.ko": "한국어",
    "language.en": "English",
    "language.es": "Español",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.de": "Deutsch",
    "language.ru": "Русский",
    "language.it": "Italiano",
    "language.hi": "हिन्दी",
    "auth.label": "Источник аутентификации",
    "auth.checking": "Проверка авторизации",
    "auth.missingCodexSession": "Сеанс Codex не обнаружен",
    "auth.switchFailed": "Не удалось переключить источник аутентификации.",
    "auth.sourceUnavailable": "{source} недоступен",
    "auth.notActive": "Не активен",
    "api.settings": "Системные настройки",
    "api.provider": "API поставщик",
    "imageInput.title": "Images",
    "imageInput.uploadAria": "Нажмите, перетащите или вставьте images.",
    "imageInput.uploadFull": "Нажмите, перетащите или вставьте images.",
    "imageInput.uploadCompact": "Добавьте image",
    "imageInput.uploadSubtitle": "Поддерживается множественная ссылка images",
    "imageInput.recent": "Последние загрузки",
    "imageInput.recentBadge": "Недавние",
    "imageInput.uploadBadge": "Загрузить",
    "imageInput.addToGallery": "Добавить в галерею",
    "imageInput.addToGalleryShort": "Галерея",
    "imageInput.removeImage": "Удалить image",
    "imageInput.editedBadge": "Отредактировано",
    "imageInput.editImage": "Изменить {name}",
    "imageInput.deletedRecent": "Последняя загрузка удалена",
    "imageInput.deletedGallery": "Галерея image удалена",
    "recentAssets.defaultName": "Последняя загрузка",
    "recentAssets.use": "Используйте {name}",
    "recentAssets.delete": "Удалить {name}",
    "recentAssets.deleteTitle": "Удалить недавнюю загрузку?",
    "recentAssets.deleteMessage": "Это приведет к удалению image из последних загрузок. Если в данный момент он выбран в качестве входа image, он будет удален из текущего входа. Исторические задачи, ссылающиеся на эту недавнюю загрузку, потеряют предварительный просмотр входных данных. Публичная галерея не затронута.",
    "recentAssets.loadFailed": "Не удалось загрузить последние загрузки.",
    "recentAssets.deleteFailed": "Не удалось удалить недавнюю загрузку.",
    "recentAssets.deleted": "Последняя загрузка удалена",
    "inputSource.uploadFallback": "Загружено image",
    "inputSource.galleryFallback": "Галерея image",
    "inputSource.focusPasteFallback": "{prefix}. Ввод Image сфокусирован; нажмите {shortcut}, чтобы вставить images.",
    "inputSource.pastedCount": "Вставлен {count} из буфера обмена images.",
    "inputSource.droppedCount": "Добавлен {count}, удален images.",
    "inputSource.dropImagesOnly": "Удалить только файлы image",
    "inputSource.clipboardUnsupported": "Этот браузер не может напрямую читать буфер обмена",
    "inputSource.clipboardEmpty": "Буфер обмена images не найден",
    "inputSource.clipboardDenied": "Браузер заблокировал прямой доступ к буферу обмена",
    "inputSource.clipboardReadFailed": "Не удалось прочитать буфер обмена",
    "status.missingGalleryReference": "Ссылка на галерею image удалена. Удалите его перед созданием.",
    "status.missingRecentReference": "Ссылка на недавнюю загрузку image была удалена. Удалите его перед созданием.",
    "status.emptyPrompt": "Введите подсказку",
    "status.editNeedsImage": "Для режима редактирования требуется хотя бы один image.",
    "status.loadedTask": "Загружено задание {taskId}",
    "status.reusedTask": "Открыта задача {taskId} в генераторе.",
    "status.loadingHistoryInputs": "Загрузка исторических данных images...",
    "status.historyInputLoadFailed": "Не удалось загрузить исторические данные image: {url}.",
    "referenceCollector.alreadyStaged": "Уже поставлен в качестве референса",
    "referenceCollector.staged": "Поэтапная ссылка {count} images",
    "referenceCollector.title": "Ожидаемые ссылки · {count}",
    "referenceCollector.addAll": "Добавить все ссылки",
    "referenceCollector.itemFallback": "Ожидается ссылка",
    "referenceCollector.remove": "Удалить ожидающую ссылку",
    "referenceCollector.cleared": "Ожидающие ссылки удалены",
    "referenceCollector.added": "Добавлена ссылка {count} images.",
    "referenceCollector.addFailed": "Не удалось добавить ожидающие ссылки.",
    "referenceCollector.readFailed": "Не удалось прочитать image: {status}.",
    "gallery.quick": "Быстрая галерея",
    "gallery.current": "Галерея текущей категории",
    "gallery.categories": "Категории галереи",
    "gallery.categoryPortrait": "Портрет",
    "gallery.categoryCharacter": "Персонаж",
    "gallery.categoryProduct": "Продукт",
    "gallery.categoryPortraitRole": "Портретный справочник",
    "gallery.categoryCharacterRole": "Ссылка на персонажа",
    "gallery.categoryProductRole": "Ссылка на продукт",
    "gallery.referenceRole": "Ссылка image",
    "gallery.manage": "Управление галереей",
    "gallery.loadFailed": "Не удалось загрузить галерею",
    "gallery.imageOrderUpdateFailed": "Не удалось обновить заказ image.",
    "gallery.imageOrderUpdated": "Image заказ обновлен",
    "gallery.categoryName": "Название категории",
    "gallery.categoryPromptRole": "Подскажите роль",
    "gallery.categorySave": "Сохранить",
    "gallery.categoryDelete": "Удалить",
    "gallery.categoryLoadFailed": "Не удалось загрузить категории.",
    "gallery.categoryNameRequired": "Введите название категории",
    "gallery.categoryCreateFailed": "Не удалось добавить категорию",
    "gallery.categoryCreated": "Категория добавлена",
    "gallery.categorySaveFailed": "Не удалось сохранить категорию",
    "gallery.categorySaved": "Категория сохранена",
    "gallery.categoryDeleteTitle": "Удалить категорию галереи?",
    "gallery.categoryDeleteMessage": "Images из этой категории перейдет в другую категорию. Галерея images не будет удалена.",
    "gallery.categoryDeleteConfirm": "Удалить категорию",
    "gallery.categoryDeleteFailed": "Не удалось удалить категорию",
    "gallery.categoryDeletedMigrated": "Категория \"{name}\" удалена, а images перенесена.",
    "gallery.categoryOrderUpdateFailed": "Не удалось обновить порядок категорий.",
    "gallery.categoryOrderUpdated": "Порядок категорий обновлен.",
    "gallery.categoryFallback": "Категория Галерея",
    "gallery.imageFallback": "Галерея image",
    "gallery.imageLoadFailed": "Не удалось загрузить этот image.",
    "gallery.editImageLoadFailed": "Не удалось загрузить этот image для редактирования.",
    "gallery.cannotAddImage": "Этот image нельзя добавить в галерею.",
    "gallery.nameRequired": "Введите название галереи",
    "gallery.saveFailed": "Не удалось сохранить галерею image.",
    "gallery.savedAsReference": "Добавлено в галерею и переключено на ссылку галереи.",
    "gallery.renameImage": "Переименуйте галерею image",
    "gallery.moveToCategory": "Перейти в категорию",
    "gallery.categoryRequired": "Выберите категорию галереи",
    "gallery.promptNoteTitle": "Справочная информация о галерее",
    "gallery.updateFailed": "Не удалось обновить галерею.",
    "gallery.selectImageFile": "Выберите файл image.",
    "gallery.replaceImageFailed": "Не удалось заменить галерею image.",
    "gallery.replacedImage": "Заменен источник image на \"{name}\".",
    "gallery.deleteImageTitle": "Удалить галерею image?",
    "gallery.deleteImageMessage": "Ссылки на исторические задачи будут отображаться как удаленные.",
    "gallery.deleteFailed": "Не удалось удалить галерею image.",
    "gallery.deletedSuffix": " (удалено)",
    "gallery.editImageLabel": "Редактировать галерею image",
    "gallery.fieldCategory": "Категория",
    "gallery.fieldPromptNote": "Справочное примечание",
    "gallery.fieldName": "Имя",
    "quickGallery.empty": "Нет {category} images",
    "promptGallery.remove": "Удалить @{name}",
    "prompt.title": "Подскажите",
    "prompt.editorLabel": "Подскажите",
    "prompt.placeholder": "Опишите image, который вы хотите создать или отредактировать. Введите @ для ссылки на галерею, # для цветовых кодов и ~ для фрагментов подсказок.",
    "prompt.run": "Генерировать",
    "prompt.runEdit": "Начать редактирование",
    "prompt.runTitle": "Создать (Cmd+Enter)",
    "prompt.runEditTitle": "Начать редактирование (Cmd+Enter)",
    "prompt.findPanel": "Найти и заменить подсказку",
    "prompt.findText": "Найти текст",
    "prompt.replaceWith": "Заменить на",
    "prompt.findActions": "Найти и заменить действия",
    "prompt.countZero": "0 совпадений",
    "prompt.matchCount": "{count} совпадений",
    "prompt.foundCount": "Найдено {count} совпадений",
    "prompt.noMatch": "Нет соответствующего текста",
    "prompt.replacedCount": "Заменены совпадения {count}.",
    "prompt.closeFind": "Закрыть поиск и замену",
    "prompt.recentTemplates": "Последние шаблоны",
    "prompt.manageTemplates": "Управление шаблонами",
    "promptModel.galleryHeader": "Ссылка image отмечает:",
    "promptModel.galleryInstruction": "- Ссылка image {number}: галерея «{name}», роль: {role}. @{name} в приглашении относится к этому image.{note}.",
    "outputSettings.title": "Вывод",
    "output.mainModel": "Основная модель",
    "output.selectMainModel": "Выберите основную модель",
    "output.mainModelCustomForInput": "Использовать пользовательскую модель для текущего ввода",
    "output.apiDirect": "API Прямой",
    "output.apiToolModel": "Использование модели API image",
    "output.mainModelUnused": "Основная модель не используется для этого запроса.",
    "output.webSearch": "Веб-поиск",
    "output.webSearchToggle": "Вкл.",
    "output.webSearchTitle": "Сначала выполните поиск в Интернете, а затем используйте его для этого поколения; Только Codex и API Responses",
    "output.promptMode": "Режим подсказки",
    "output.modeOriginal": "Оригинал",
    "output.modeStrict": "Верный",
    "output.modeCreative": "Креатив",
    "output.sizeMode": "Режим размера",
    "output.sizePreset": "Предустановка",
    "output.sizeCustom": "Пользовательский",
    "output.orientation": "Ориентация",
    "output.square": "Площадь",
    "output.portrait": "Портрет",
    "output.landscape": "Пейзаж",
    "output.resolution": "Разрешение",
    "output.pixelSize": "Размер пикселя",
    "output.width": "Ширина",
    "output.height": "Высота",
    "output.swapSize": "Поменять местами ширину и высоту",
    "output.customSizeHint": "Единица измерения пикс · 16-3840 · кратно 16 · ≤3:1",
    "output.imageSizeUnavailable": "Размер Image недоступен",
    "output.imageLoadFailed": "Image не удалось загрузить",
    "output.customSizeRequired": "Введите ширину и высоту",
    "output.customSizeBounds": "Ширина и высота должны быть 16–3840 пикселей.",
    "output.customSizeMultiple": "Ширина и высота должны быть кратны 16.",
    "output.customSizeRatio": "Соотношение длинной и короткой сторон не может превышать 3:1.",
    "output.customSizePixels": "Общее количество пикселей должно быть от 655 360 до 8 294 400.",
    "output.ratioLock": "Блокировка соотношения (опция)",
    "output.customRatio": "Пользовательское соотношение сторон",
    "output.ratioWidth": "Вт",
    "output.ratioHeight": "Ч",
    "output.firstImageRatio": "Используйте первое эталонное соотношение сторон image.",
    "output.useFirstImage": "От image",
    "output.ratioHint": "Оставьте пустым для свободного размера · Заполните оба поля для синхронизации.",
    "output.ratio": "Соотношение",
    "output.quality": "Качество",
    "output.qualityAuto": "Авто",
    "output.qualityLow": "Низкий",
    "output.qualityMedium": "Средний",
    "output.qualityHigh": "Высокий",
    "output.quantity": "Граф",
    "output.pixelPreview": "Выходные пиксели: 1024 x 1024 пикселей.",
    "output.pixelPreviewValue": "Выходные пиксели: {value}",
    "output.pixelPreviewAuto": "Выходные пиксели: auto (OpenAI выбирается автоматически)",
    "output.format": "Формат",
    "output.compression": "Сжатие",
    "output.moderation": "Модерация",
    "preview.title": "Предварительный просмотр",
    "preview.selectedZero": "0 выбрано",
    "preview.selectedCount": "Выбрано {selected}/{total}",
    "preview.downloadSelected": "Скачать выбранное",
    "preview.deleteUnselected": "Удалить невыбранное",
    "preview.downloadAll": "Скачать ZIP",
    "preview.empty": "images пока нет",
    "preview.taskFailed": "Задача не выполнена",
    "preview.partialFailed": "Некоторый images не удался",
    "preview.failedOutput": "Image {index} не удалось",
    "preview.progressLine": "Завершено {generated} / {total} · истекло {elapsed}",
    "preview.failureLine": "Завершено {generated} / {total} · не удалось {failed}",
    "preview.elapsedLine": "Прошло {elapsed}",
    "preview.lastError": "Последняя ошибка: {error}",
    "preview.continueGenerating": "Продолжающееся поколение",
    "preview.waitingContinue": "Ожидание продолжения",
    "preview.retryFailed": "Повторная попытка не удалась images",
    "preview.acceptSuccesses": "Примите успешные результаты",
    "preview.generateMode": "Поколение",
    "preview.editMode": "Редактировать",
    "preview.runningTitle": "{mode} работает",
    "preview.submittingTitle": "Отправка задачи",
    "preview.queuedTitle": "Задача поставлена в очередь",
    "preview.submittingDetail": "Сохранение входных данных и добавление задачи в очередь. Генерация начнется автоматически.",
    "preview.queuedDetail": "Задача находится в очереди и ожидает доступного канала.",
    "preview.featured": "Выбрано",
    "preview.addFeatured": "Выберите результат",
    "preview.selectedFeatured": "Выбрано",
    "preview.removeFeatured": "Отменить выбор результата",
    "preview.selectionAdded": "Результат выбран",
    "preview.selectionRemoved": "Результат снят с выбора",
    "preview.selectionUpdateFailed": "Не удалось обновить выбор.",
    "preview.noUnselectedOutputs": "Нет невыбранного images для удаления",
    "preview.deleteUnselectedTitle": "Удалить невыделенный images?",
    "preview.deleteUnselectedMessage": "Это приведет к удалению локальных файлов image для невыбранных результатов в этой задаче.",
    "preview.deleteUnselectedDetail": "Оставьте {selected}, удалите {deleted}.",
    "preview.deleteUnselectedFailed": "Не удалось удалить невыделенный images.",
    "preview.deleteUnselectedDone": "Невыбранный images удален",
    "preview.addReference": "Добавить ссылку",
    "preview.stage": "Этап",
    "preview.stageReference": "Этап как ожидающая ссылка",
    "preview.prompt": "Подскажите",
    "preview.download": "Скачать",
    "preview.downloadImage": "Загрузите этот image",
    "lightbox.label": "Image предварительный просмотр",
    "lightbox.close": "Закрыть предварительный просмотр",
    "lightbox.previous": "Предыдущий image",
    "lightbox.next": "Следующий image",
    "promptPopover.title": "Быстрое сравнение",
    "promptPopover.summary": "Исходный {original} · оптимизированный {optimized}",
    "promptPopover.original": "Оригинальная подсказка",
    "promptPopover.optimized": "Оптимизированная подсказка",
    "promptPopover.charCount": "{count} символов",
    "promptPopover.empty": "Нет",
    "promptPopover.notReturned": "Не возвращено",
    "promptPopover.noOptimized": "Оптимизированное приглашение не возвращено",
    "promptPopover.submitted": "Посмотреть отправленное приглашение",
    "promptPopover.close": "Закрыть быстрое сравнение",
    "promptPopover.copyOptimized": "Копировать оптимизированное приглашение",
    "promptPopover.copied": "Скопировано",
    "taskContext.menuLabel": "Контекстное меню задачи",
    "taskContext.view": "Посмотреть задачу",
    "taskContext.copyId": "Копировать задачу ID",
    "taskContext.copyPrompt": "Копировать приглашение",
    "taskContext.revealOutput": "Открыть выходную папку",
    "taskContext.archive": "Задача архивирования",
    "taskContext.delete": "Удалить задачу",
    "taskContext.idCopied": "Task ID скопировано",
    "taskContext.promptCopied": "Подсказка скопирована.",
    "taskContext.noPrompt": "Для этой задачи нет запроса на копирование",
    "taskContext.revealFailed": "Не удалось открыть папку вывода.",
    "taskContext.revealOpened": "Выходная папка открыта",
    "taskContext.actionFailed": "Не удалось выполнить действие задачи",
    "taskActions.group": "Действия задачи",
    "taskActions.deleteTitle": "Удалить задачу?",
    "taskActions.deleteMessage": "Это также приведет к удалению локальных файлов image.",
    "taskActions.runningCannotDelete": "Запущенные задачи не могут быть удалены",
    "taskActions.updated": "Статус задачи обновлен",
    "taskActions.archived": "Чат в архиве",
    "taskActions.archiveFailed": "Архив не выполнен",
    "taskActions.deleted": "Задача удалена",
    "taskActions.deleteFailed": "Удаление не удалось",
    "taskActions.noRetryableFailedImages": "Для этой задачи не удалось повторить попытку images.",
    "taskActions.retryFailedOutputsFailed": "Не удалось повторить попытку images.",
    "taskActions.requeuedFailedImages": "Ошибка: images отправлен в очередь.",
    "taskActions.noAcceptableSuccessImages": "Эта задача не имеет успешного images для принятия.",
    "taskActions.acceptSuccessesFailed": "Не удалось принять успешные результаты",
    "taskActions.acceptedSuccesses": "Успешные результаты приняты",
    "taskActions.viewedUpdateFailed": "Не удалось обновить состояние чтения.",
    "taskActions.failedFallback": "Задача не выполнена",
    "taskList.empty": "Пока нет истории",
    "taskList.selectSession": "Выберите чат",
    "taskList.unreadUpdate": "Непрочитанное обновление",
    "taskList.viewing": "Просмотр",
    "taskDerived.usageLimited": "Использование ограничено",
    "taskSubmit.requestFailed": "Запрос не выполнен",
    "taskSubmit.queued": "Задача добавлена в очередь",
    "taskSubmit.timeout": "Время ожидания отправки задачи истекло, прежде чем серверная часть ответила. Обновите очередь, чтобы подтвердить, была ли она добавлена, а затем решите, повторять ли попытку.",
    "taskSubmit.failed": "Отправка задачи не удалась",
    "templates.title": "Шаблоны подсказок",
    "templates.summary": "Локальная библиотека шаблонов",
    "templates.availableCount": "{count} доступные шаблоны",
    "templates.noMatch": "Нет подходящих шаблонов",
    "templates.empty": "Нет шаблонов",
    "templates.favoriteBadge": "Любимый",
    "templates.usageCount": "{count} использует",
    "templates.back": "Назад",
    "templates.edit": "Редактировать",
    "templates.copy": "Копировать",
    "templates.insert": "Вставить",
    "templates.formTitle": "Название",
    "templates.formShortTitle": "Краткое название",
    "templates.formCategory": "Категория",
    "templates.formTags": "Теги",
    "templates.formThumbnail": "Миниатюра",
    "templates.formContent": "Содержание",
    "templates.formNotes": "Примечания",
    "templates.formFavorite": "Любимый",
    "templates.thumbnailClear": "Очистить",
    "templates.thumbnailNone": "Ничего не выбрано",
    "templates.thumbnailEmpty": "Нет миниатюр истории",
    "templates.newCategory": "Новая категория",
    "templates.search": "Шаблоны поиска, теги или контент",
    "templates.filter": "Фильтры шаблонов",
    "templates.all": "Все",
    "templates.categoryCommon": "Общий",
    "templates.categoryPortrait": "Портрет",
    "templates.categoryProduct": "Продукт",
    "templates.categoryRepair": "Ремонт",
    "templates.categoryPoster": "Плакат",
    "templates.categoryEcommerce": "Электронная коммерция",
    "templates.favorite": "Избранное",
    "templates.recent": "Недавние",
    "templates.category": "Категории",
    "templates.loadFailed": "Не удалось загрузить шаблоны подсказок.",
    "templates.useStateUpdateFailed": "Не удалось обновить состояние использования шаблона приглашения.",
    "templates.copied": "Шаблон запроса скопирован.",
    "templates.copyFailed": "Не удалось скопировать шаблон приглашения.",
    "templates.history": "История",
    "templates.saveFailed": "Не удалось сохранить шаблон приглашения.",
    "templates.saved": "Шаблон приглашения сохранен.",
    "templates.deleteFailed": "Не удалось удалить шаблон приглашения.",
    "templates.deleted": "Шаблон запроса удален.",
    "templates.categoryAddFailed": "Не удалось добавить категорию шаблона.",
    "templates.categoryAdded": "Добавлена категория шаблонов",
    "templates.categorySaveFailed": "Не удалось сохранить категорию шаблона.",
    "templates.categorySaved": "Категория шаблона сохранена.",
    "templates.categoryDeleteFailed": "Не удалось удалить категорию шаблонов.",
    "templates.categoryDeleted": "Категория шаблонов удалена.",
    "templates.importFailed": "Не удалось импортировать пакет шаблонов.",
    "templates.importedCount": "Импортированные шаблоны {count}",
    "templates.exportFailed": "Не удалось экспортировать пакет шаблонов.",
    "templates.exported": "Пакет шаблонов экспортирован.",
    "snippets.suggestLabel": "Быстрый выбор фрагмента",
    "snippets.saveSelection": "Сохранить",
    "snippets.saveSelectionLabel": "Сохранить выделенный текст как фрагмент подсказки",
    "snippets.popoverLabel": "Фрагмент запроса",
    "snippets.defaultCategory": "Общий",
    "snippets.loadFailed": "Не удалось загрузить фрагменты подсказок.",
    "snippets.remove": "Удалить ~{tag}",
    "snippets.expand": "Развернуть",
    "snippets.edit": "Редактировать",
    "snippets.close": "Закрыть",
    "snippets.editTitle": "Изменить фрагмент",
    "snippets.saveTitle": "Сохранить фрагмент",
    "snippets.shortTag": "Короткий тег",
    "snippets.title": "Название",
    "snippets.category": "Категория",
    "snippets.content": "Содержание",
    "snippets.titlePlaceholder": "По умолчанию использует короткий тег",
    "snippets.cancel": "Отмена",
    "snippets.save": "Сохранить",
    "snippets.saveFailed": "Не удалось сохранить фрагмент запроса.",
    "snippets.saved": "Фрагмент запроса сохранен.",
    "snippets.defaultTag": "Общий фрагмент",
    "colors.white": "Белый",
    "colors.black": "Черный",
    "colors.warmBeige": "Теплый бежевый",
    "colors.lightGreen": "Светло-зеленый",
    "colors.brandGreen": "Фирменный зеленый",
    "colors.peachOrange": "Персиковый апельсин",
    "colors.lightBlue": "Голубой",
    "colors.lightPink": "Светло-розовый",
    "colors.loadFailed": "Не удалось загрузить настройки цвета.",
    "colors.saveFailed": "Не удалось сохранить настройки цвета.",
    "colors.importFailed": "Не удалось импортировать настройки цвета.",
    "colors.importedCount": "Импортированы цвета {count}.",
    "colors.recentSaveFailed": "Не удалось сохранить последние цвета.",
    "colors.favoriteSaveFailed": "Не удалось сохранить любимый цвет.",
    "colors.favoriteDeleteFailed": "Не удалось удалить любимый цвет.",
    "colors.update": "Обновить",
    "colors.insert": "Вставить",
    "colors.pick": "Выберите цвет",
    "colors.pickShort": "Выбрать",
    "colors.hexValue": "Значение цвета",
    "colors.pendingUpdate": "Цвет изменился. Нажмите «Обновить», чтобы применить.",
    "colors.save": "Сохранить",
    "colors.exportPs": "Экспорт",
    "colors.importPs": "Импорт",
    "colors.done": "Готово",
    "colors.manage": "Управление",
    "colors.favorites": "Любимые цвета",
    "colors.recent": "Последние цвета",
    "colors.recentLabel": "Недавние",
    "colors.deleteFavorite": "Удалить любимый цвет {name}",
    "colors.modify": "Изменить цвет",
    "colors.modifyValue": "Изменить цвет {value}",
    "colors.removeValue": "Удалить цвет {value}",
    "taskGroup.today": "Сегодня",
    "taskGroup.yesterday": "Вчера",
    "taskGroup.last7": "Последние 7 дней",
    "taskGroup.older": "Старше",
    "taskGroup.searchResults": "Результаты поиска",
    "taskGroup.active": "Активный",
    "taskGroup.running": "Бег",
    "taskGroup.waiting": "Ожидание",
    "taskGroup.dispatchPending": "Назначение доступного канала...",
    "taskGroup.expand": "Развернуть {label}",
    "taskGroup.collapse": "Свернуть {label}",
    "taskGroup.buttonLabel": "{label}, {count} задач",
    "archive.title": "Архив",
    "archive.empty": "Нет архивированных чатов",
    "archive.count": "{count} архивированные чаты",
    "archive.restore": "Восстановить",
    "archive.archiveFailed": "Архив не выполнен",
    "archive.restoreFailed": "Восстановление не удалось",
    "archive.restored": "Чат восстановлен",
    "archive.archiving": "Архивирование...",
    "archive.restoring": "Восстановление...",
    "archive.deleting": "Удаление...",
    "archive.restoredCount": "Восстановлены задачи {count}.",
    "settings.title": "Хранение",
    "settings.status": "Перезапустите WebUI после сохранения путей хранения.",
    "settings.inputRoot": "Входная папка",
    "settings.outputRoot": "Выходная папка",
    "settings.galleryRoot": "Папка галереи",
    "settings.sourceDataRoot": "Папка исходных данных",
    "settings.chooseDirectory": "Выбрать папку",
    "settings.language": "Язык интерфейса",
    "settings.languageCopy": "При первом запуске интерфейс использует язык браузера. Ручной выбор сохраняется.",
    "settings.notificationsCopy": "Уведомляйте, когда задачи выполняются или не выполняются. Системные уведомления необходимо включить вручную.",
    "settings.inAppNotification": "Уведомления в приложении",
    "settings.systemNotification": "Системные уведомления",
    "settings.save": "Сохранить настройки",
    "settings.loadFailed": "Не удалось загрузить настройки",
    "settings.saveFailed": "Не удалось сохранить настройки.",
    "settings.savedRestart": "Настройки хранилища сохранены. Перезапустите WebUI, чтобы применить.",
    "settings.saved": "Сохранено",
    "settings.savedRestartStatus": "Настройки хранилища сохранены. Перезапустите WebUI, чтобы применить.",
    "systemSettings.title": "Системные настройки",
    "systemSettings.tabsLabel": "Разделы системных настроек",
    "systemSettings.apiTab": "API Настройки",
    "systemSettings.codexTab": "Codex Канал",
    "systemSettings.languageTab": "Язык / Language",
    "systemSettings.storageTab": "Уведомления",
    "languageSettings.instantStatus": "Сохранено. Применено сразу.",
    "apiSettings.title": "API Настройки",
    "apiSettings.status": "Сохраненные настройки применяются немедленно в режиме API.",
    "apiSettings.codexMode": "Codex канал",
    "apiSettings.codexImages": "Image",
    "apiSettings.codexResponses": "Responses",
    "apiSettings.providers": "API поставщики",
    "apiSettings.providerCount": "{count} поставщиков",
    "apiSettings.provider": "Поставщик",
    "apiSettings.providerName": "Имя провайдера",
    "apiSettings.newProviderAction": "Новый провайдер",
    "apiSettings.copyProvider": "Копировать",
    "apiSettings.copyProviderName": "{name} Копировать",
    "apiSettings.copyProviderStatus": "Провайдер скопировал свой сохраненный ключ. Перед сохранением отредактируйте имя, модель или замените ключ.",
    "apiSettings.copyProviderWithoutKeyStatus": "Провайдер скопировал. Перед сохранением отредактируйте имя, модель или добавьте ключ API.",
    "apiSettings.sortProviders": "Сортировать",
    "apiSettings.finishSortProviders": "Готово",
    "apiSettings.sortProviderModeStatus": "Сортировка поставщиков",
    "apiSettings.sortProviderStatus": "Порядок провайдера изменен. Сохраните текущий выбор, чтобы синхронизировать его.",
    "apiSettings.moveProviderUp": "Вверх",
    "apiSettings.moveProviderDown": "Вниз",
    "apiSettings.moveProviderUpAria": "Переместить {provider} вверх",
    "apiSettings.moveProviderDownAria": "Переместить {provider} вниз",
    "apiSettings.mode": "Режим запроса",
    "apiSettings.images": "Прямой Image API",
    "apiSettings.responses": "Responses API",
    "apiSettings.modeImagesShort": "Прямой",
    "apiSettings.imageModel": "Модель Image",
    "apiSettings.concurrency": "Ограничение параллелизма поставщика",
    "apiSettings.concurrencyShort": "Параллелизм",
    "apiSettings.concurrencyValue": "параллелизм {concurrency}",
    "apiSettings.keySaved": "Ключ API сохранен.",
    "apiSettings.keyNotSet": "Ключ API не установлен",
    "apiSettings.editProvider": "Изменить поставщика",
    "apiSettings.newProviderTitle": "Новый провайдер",
    "apiSettings.editHint": "Поставщик сохранения записывает это изменение на серверную часть. Отмена отменяет его.",
    "apiSettings.finishEditFirst": "Сначала сохраните или отмените изменение текущего поставщика.",
    "apiSettings.newDraftStatus": "Создание провайдера. Сохраните поставщика, чтобы подать заявку.",
    "apiSettings.editDraftStatus": "Редактирование провайдера. Сохраните поставщика, чтобы подать заявку.",
    "apiSettings.cancelEdit": "Отменить редактирование",
    "apiSettings.saveProvider": "Сохранить поставщика",
    "apiSettings.saveSelection": "Сохранить выбор",
    "apiSettings.deleteProviderTitle": "Удалить провайдера?",
    "apiSettings.deleteProviderMessage": "Удалить \"{provider}\"?",
    "apiSettings.deleteProviderDetail": "Это удалит его из списка поставщиков. Сохраните текущий выбор, чтобы синхронизировать его с серверной частью.",
    "apiSettings.deleteProviderStatus": "Провайдер удален. Сохраните текущий выбор, чтобы синхронизировать его с серверной частью.",
    "apiSettings.save": "Сохраните настройки API",
    "apiSettings.loadFailed": "Не удалось загрузить настройки API.",
    "apiSettings.savedKeyPlaceholder": "Ключ API сохраняется на сервере. Введите новый ключ для его замены.",
    "apiSettings.newProvider": "Новый провайдер",
    "apiSettings.saving": "Сохранение...",
    "apiSettings.savingStatus": "Сохранение настроек API...",
    "apiSettings.saveFailed": "Не удалось сохранить настройки API.",
    "apiSettings.savedSummary": "Сохранено · Codex {codex} · API {provider} · {mode} · {model} · параллелизм {concurrency}",
    "apiSettings.savedShort": "Сохранено",
    "apiSettings.savedStatus": "Настройки API сохранены.",
    "apiSettings.saveFailedShort": "Сохранить не удалось",
    "codexSettings.title": "Codex Канал",
    "codexSettings.status": "Выберите канал генерации для локального входа Codex.",
    "codexSettings.notesLabel": "Codex примечания к каналу",
    "codexSettings.imagesTitle": "Image",
    "codexSettings.imagesCopy": "Канал по умолчанию для прямой передачи размера, качества и редактирования параметров.",
    "codexSettings.responsesTitle": "Responses",
    "codexSettings.responsesCopy": "Канал совместимости для рабочих процессов, требующих инструментов веб-поиска.",
    "codexSettings.save": "Сохранить канал Codex",
    "imageEditor.title": "Редактировать ввод Image",
    "imageEditor.promptHint": "Нарисованные от руки стрелки и метки в image являются всего лишь инструкциями. Не оставляйте их в конечном файле image.",
    "imageEditor.inputFallback": "Введите image",
    "imageEditor.openFailed": "Не удалось открыть этот image для редактирования.",
    "imageEditor.loadForEditFailed": "Не удалось загрузить этот image для редактирования.",
    "imageEditor.canvasCreateFailed": "Не удалось создать холст редактирования image.",
    "imageEditor.closedRegionRequired": "Используйте кисть, чтобы сначала нарисовать замкнутую область.",
    "imageEditor.saveFailed": "Не удалось сохранить изменение image.",
    "imageEditor.saved": "Отредактированный ввод image сохранен.",
    "imageEditor.uneditable": "Этот image нельзя редактировать.",
    "imageEditor.resetDone": "Сброс до original image",
    "imageEditor.resetFailed": "Не удалось сбросить original image.",
    "imageEditor.subtitle": "Обрезайте, рисуйте, заливайте или добавляйте стрелки, а затем сохраните как новый ввод image.",
    "imageEditor.toolbar": "Image панель инструментов редактора",
    "imageEditor.tools": "Инструменты",
    "imageEditor.select": "Выбрать",
    "imageEditor.brush": "Кисть",
    "imageEditor.arrow": "Стрелка",
    "imageEditor.crop": "Обрезка",
    "imageEditor.fill": "Заполнить",
    "imageEditor.fillLabel": "Заполнение ведра с краской",
    "imageEditor.eraser": "Ластик",
    "imageEditor.colors": "Цвета",
    "imageEditor.red": "Красный",
    "imageEditor.blue": "Синий",
    "imageEditor.green": "Зеленый",
    "imageEditor.yellow": "Желтый",
    "imageEditor.white": "Белый",
    "imageEditor.black": "Черный",
    "imageEditor.customColor": "Пользовательский цвет",
    "imageEditor.stroke": "Инсульт",
    "imageEditor.history": "История",
    "imageEditor.undo": "Отменить",
    "imageEditor.redo": "Повторить",
    "imageEditor.reset": "Сбросить image",
    "imageEditor.canvas": "Image редактирование холста",
    "imageEditor.canvasScope": "Область холста",
    "imageEditor.canvasScopeBase": "Исходное изображение",
    "imageEditor.canvasScopeFit": "По слоям",
    "imageEditor.canvasFitDone": "Холст подогнан под слои",
    "imageEditor.canvasBaseDone": "Холст возвращён к исходному изображению",
    "imageEditor.insertImages": "Вставить изображения",
    "imageEditor.layers": "Слои",
    "imageEditor.layerUp": "Переместить выше",
    "imageEditor.layerDown": "Переместить ниже",
    "imageEditor.emptyInsertList": "Нет других входных изображений",
    "imageEditor.selectLayerFirst": "Сначала выберите слой",
    "imageEditor.baseLayer": "Базовое изображение",
    "gallery.title": "Галерея",
    "gallery.subtitle": "Выберите ссылку images для текущей задачи.",
    "gallery.manageCategories": "Управление категориями",
    "gallery.categoryManager": "Управление категориями галереи",
    "gallery.categoryManagement": "Категорийный менеджмент",
    "gallery.categoryCopy": "Категории сохраняются в галерее; роли приглашения описывают, как используются ссылки.",
    "gallery.newCategoryName": "Новое название категории",
    "gallery.newCategoryRole": "Роль подсказки, например. ссылка на стиль",
    "gallery.addCategory": "Добавить категорию",
    "gallery.drawerSubtitle": "Текущая категория: {category}. Нажмите «Использовать», чтобы добавить его во вход image.",
    "gallery.emptyCategory": "В этой категории пока нет images",
    "gallery.dragSort": "Перетащите для сортировки",
    "gallery.dragSortImage": "Сортировка перетаскиванием image {name}",
    "gallery.dragSortCategory": "Категория сортировки перетаскиванием {name}",
    "gallery.use": "Использование",
    "gallery.replace": "Заменить",
    "gallery.rename": "Переименовать",
    "gallery.moveCategory": "Категория",
    "gallery.note": "Примечание",
    "gallery.delete": "Удалить",
    "gallery.uncategorized": "Без категории",
    "addGallery.title": "Добавить в галерею",
    "addGallery.copy": "Имена глобально уникальны, и позже на них можно будет ссылаться с помощью @name.",
    "addGallery.name": "Имя",
    "addGallery.namePlaceholder": "Пример: Миа",
    "addGallery.category": "Категория",
    "addGallery.note": "Справочное примечание",
    "addGallery.notePlaceholder": "Пример: укажите только лицо и волосы, а не одежду или фон.",
    "addGallery.save": "Сохранить в галерею",
    "close.promptTemplates": "Закрыть панель шаблонов подсказок",
    "close.archive": "Закрыть панель архива",
    "close.settings": "Закрыть панель настроек хранилища",
    "close.apiSettings": "Закрыть панель настроек API",
    "close.systemSettings": "Закрыть панель настроек системы",
    "close.imageEditor": "Закрыть панель редактора image",
    "close.gallery": "Закрыть панель галереи",
    "close.addGallery": "Закрыть панель добавления в галерею",
    "close.version": "Закрыть панель обновления версии"
};


